<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between">
        <div class="mr-auto">
          <h6>综合考评</h6>
        </div>
        <div>
          <a v-b-toggle.collapse-rating role="button" style="color: #606266">
            <i v-if="isRating" class="fa fa-chevron-down" title="收起"></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </div>
      </div>
      <b-collapse v-model="isRating" id="collapse-rating">
        <div class="d-flex mt-2">
          <div style="width: 250px">
            <span class="text-muted" style="font-size: 14px">考评总分： </span>
          </div>
          <div style="width: 100%">
            <span style="font-size: 14px">{{ formData.totalTopScore }}</span>
          </div>
        </div>
        <div class="d-flex mt-2">
          <div style="width: 250px">
            <span class="text-muted" style="font-size: 14px">综合得分：</span>
          </div>
          <div style="width: 100%">
            <span style="font-size: 14px">{{ formData.scmScore }}</span>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px"
              >达标率：{{ formData.scmScoreRatio }}</span
            >
          </div>
        </div>
        <div style="width: 100%; height: 300px" class="mt-4">
          <v-echarts
            :option="optionsRating"
            auto-resize="true"
            theme="light"
            style="width: 100%; height: 100%"
            ref="echartsRating"
          ></v-echarts>
        </div>
        <div v-for="(item, index) in formData.scoreList" :key="index">
          <h6 class="mt-2">{{ item.displayText }}</h6>
          <div
            class="d-flex justify-content-between"
            v-for="(itemDetail, seqno) in item.scoreItemList"
            :key="seqno"
          >
            <div style="flex:1;">
              <span class="text-muted" style="font-size: 14px">{{
                itemDetail.displayText
              }}</span>
            </div>
            <div>
              <span style="font-size: 14px">{{
                itemDetail.appraisalItemValue
              }}</span>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    params: {
      default: null,
      type: Object
    },
    autoLoad: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    params: {
      handler() {
        if (this.autoLoad) {
          this.init(this.params)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isRating: true,
      formData: {
        totalTopScore: '',
        scmScore: '',
        scmScoreRatio: '',
        scoreList: []
      },
      optionsRating: {}
    }
  },
  mounted() {
    window.addEventListener('resize', this.resizeTheChart)
  },
  activated() {
    window.addEventListener('resize', this.resizeTheChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeTheChart)
  },
  methods: {
    init(params) {
      this.getData(params)
    },
    getData(params) {
      this.isBusy = true
      this.$api
        .opaScmScoreGetScoreListApi(params)
        .then((res) => {
          this.isBusy = false
          this.formData = res.body
          // 设置图形数据参数
          this.setChartsData()
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    setChartsData() {
      this.optionsRating = {
        title: {},
        tooltip: {},
        legend: {
          data: []
        },
        radar: {
          shape: 'circle',
          name: {
            textStyle: {
              color: '#fff',
              backgroundColor: '#999',
              borderRadius: 3,
              padding: [3, 5]
            }
          },
          indicator: this.formData.chartsIndicator,
          center: ['50%', '50%'],
          radius: 100
        },
        series: [
          {
            type: 'radar',
            areaStyle: {},
            data: this.formData.chartsData
          }
        ]
      }
    },
    resizeTheChart() {
      if (this.$refs.echartsRating) {
        this.$refs.echartsRating.resize()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.card {
  margin: 20px 10px;
}
</style>
